export const URL_BUFFET = "https://da.prefeitura.unicamp.br/"
export const URL_DM = "https://dm.prefeitura.unicamp.br/"
export const URL_DMA = "https://dma.prefeitura.unicamp.br/"
export const URL_DAE = "https://dae.prefeitura.unicamp.br/"
export const URL_CAD_FRETADOS = "https://sistemas.prefeitura.unicamp.br/apps/cad_fretados/"
export const URL_EVENTOS = "https://prefeitura.unicamp.br/solicitacao-de-eventos/"
export const URL_SSR = "https://paralamas.prefeitura.unicamp.br/ssr/"
export const URL_TAXI = "https://originaltaxi.com.br/portal/login/gneexecutivo" 
export const URL_UNITRANSP = "https://unitransp.prefeitura.unicamp.br/"
export const URL_DM_ONET = "https://onetbrasil-unicamp.globalthings.net//Login.aspx"
export const URL_SOLICITACAO_TRANSPORTE = "https://sistemas.prefeitura.unicamp.br/apps/solicitacao_transporte/";
export const URL_DM_RP = "https://rp.prefeitura.unicamp.br/";